import { z } from 'zod'
import { parseKwacha } from '@/lib/money'

export function amountToNgwee(text: string): number | null {
  const n = parseKwacha(text)
  return n !== null && n > 0 ? n : null
}

export const remittanceFormSchema = z
  .object({
    movedOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Pick the date it was sent'),
    amount: z.string().refine((v) => amountToNgwee(v) !== null, 'Enter an amount like 500 or 500.00'),
    method: z.enum(['cash', 'mobile_money', 'bank_transfer']),
    handedTo: z.string().trim().max(80, 'Use a shorter name'),
    handedBy: z.string().trim().max(80, 'Use a shorter name'),
    bankRef: z.string().trim().max(60, 'Use a shorter reference'),
    slipNo: z.string().trim().max(60, 'Use a shorter slip number'),
    note: z.string().trim().max(300, 'Use a shorter note'),
  })
  .superRefine((v, ctx) => {
    if (v.method === 'cash' && v.handedTo === '') {
      ctx.addIssue({ code: 'custom', path: ['handedTo'], message: 'Say who received the cash' })
    }
    if (v.method !== 'cash' && v.bankRef === '') {
      ctx.addIssue({ code: 'custom', path: ['bankRef'], message: 'Enter the bank or mobile money reference, so central treasury can find it' })
    }
  })

export const reasonSchema = z.object({
  reason: z.string().trim().min(3, 'Give a reason (at least a few words)').max(300, 'Use a shorter reason'),
})
